<template>
  <footer class="site-footer" v-if="!isAdminPage">

    <!-- 상단: 현장 정보 -->
    <div class="footer-top">
      <div class="footer-inner">
        <h3 class="footer-project-name">서수원 에피트 센트럴마크</h3>
      </div>
    </div>

    <!-- 고지사항 -->
    <div class="footer-disclaimer">
      <div class="footer-inner">
        <p class="footer-ad-agency">광고대행사: (주)더한걸음 | <a href="mailto:info@step1.kr" class="footer-email">info@step1.kr</a></p>
        <p class="footer-disclaimer-text">
          본 사이트는 서수원 에피트 센트럴마크 정보 제공 페이지입니다.
        </p>
        <div class="footer-notices">
          <p>※ 본 사이트는 분양 상담 및 방문 예약 안내를 위한 사이트이며, 사업 및 분양과 관련된 자세한 사항은 상담을 통해 안내받으실 수 있습니다.</p>
          <p>본 사이트는 서수원 에피트 센트럴마크 분양 상담 및 방문 예약 안내를 위한 홍보 상담 페이지입니다.</p>
          <p>시행사 및 시공사의 공식 홈페이지가 아니며 상담 안내 서비스를 제공하는 페이지입니다.</p>
          <p>분양 관련 상세 정보는 모델하우스 상담을 통해 안내받으실 수 있습니다.</p>
          <p>시행 : (주) 디허브</p>
          <p>시공 : HL디앤아이한라(주)</p>
          <p>광고주체: 주식회사 더한걸음</p>
          <p>광고주체 사업자등록번호: 820-87-03644</p>
          <p>담당자: 김선진</p>
        </div>
      </div>
    </div>

    <!-- 하단: 개인정보처리방침 + 카피라이트 -->
    <div class="footer-bottom">
      <div class="footer-inner">
        <button class="footer-privacy-btn" @click="showPrivacy = true">개인정보 처리방침</button>
        <p class="footer-copyright">&copy; {{ currentYear }} 서수원 에피트 센트럴마크. All rights reserved.</p>
      </div>
    </div>

    <!-- 개인정보처리방침 모달 -->
    <transition name="modal-fade">
      <div class="privacy-overlay" v-if="showPrivacy" @click.self="showPrivacy = false">
        <div class="privacy-modal">
          <div class="privacy-modal-header">
            <h3>개인정보처리방침</h3>
            <button class="privacy-close" @click="showPrivacy = false">&times;</button>
          </div>
          <div class="privacy-modal-body">
            <p class="privacy-intro">주식회사 더한걸음은 고객님의 개인정보를 소중히 보호합니다.</p>

            <h4>제1조 (개인정보의 수집 및 이용 목적)</h4>
            <p>주식회사 더한걸음(이하 "회사")은 서수원 에피트 센트럴마크 사이트(이하 "사이트")를 운영함에 있어 다음의 목적을 위해 개인정보를 수집 및 이용합니다.</p>
            <ul>
              <li>분양 상담 및 방문 예약 안내</li>
              <li>방문예약 및 상담 연락</li>
              <li>고객 문의 응대 및 상담 이력 관리</li>
              <li>마케팅 및 프로모션 정보 제공 (동의 시)</li>
            </ul>

            <h4>제2조 (수집하는 개인정보의 항목)</h4>
            <p>회사는 분양 상담 및 방문예약을 위해 다음의 개인정보를 수집합니다.</p>
            <table class="privacy-table">
              <thead>
                <tr><th>수집 항목</th><th>수집 목적</th><th>보유 기간</th></tr>
              </thead>
              <tbody>
                <tr><td>이름, 연락처(휴대폰번호)</td><td>분양 상담 및 방문 예약 안내</td><td>수집일로부터 1년</td></tr>
              </tbody>
            </table>

            <h4>제3조 (개인정보의 수집 방법)</h4>
            <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
            <ul>
              <li>사이트 내 방문예약 양식을 통한 수집</li>
              <li>전화 상담을 통한 수집</li>
            </ul>

            <h4>제4조 (개인정보의 보유 및 이용 기간)</h4>
            <p>회사는 개인정보의 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관련 법령에 의해 보존이 필요한 경우 해당 기간 동안 보관합니다.</p>
            <ul>
              <li>방문예약 정보: 수집일로부터 1년</li>
              <li>상담 이력: 수집일로부터 1년</li>
              <li>단, 관계 법령에 의해 보존할 필요가 있는 경우 해당 법령에서 정한 기간 동안 보관</li>
            </ul>

            <h4>제5조 (개인정보의 제3자 제공)</h4>
            <p>회사는 고객의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
            <ul>
              <li>고객이 사전에 동의한 경우</li>
              <li>법령의 규정에 의하거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
            </ul>

            <h4>제6조 (개인정보의 파기 절차 및 방법)</h4>
            <p>회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
            <ul>
              <li>파기 절차: 불필요한 개인정보는 개인정보 관리책임자의 승인을 받아 파기합니다.</li>
              <li>파기 방법: 전자적 파일 형태의 정보는 기술적 방법을 사용하여 복원이 불가능하도록 삭제하며, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</li>
            </ul>

            <h4>제7조 (정보주체의 권리·의무 및 행사 방법)</h4>
            <p>고객은 개인정보 주체로서 다음과 같은 권리를 행사할 수 있습니다.</p>
            <ul>
              <li>개인정보 열람 요구</li>
              <li>오류 등이 있을 경우 정정 요구</li>
              <li>삭제 요구</li>
              <li>처리 정지 요구</li>
            </ul>
            <p>위 권리 행사는 회사에 대해 서면, 전화, 이메일 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.</p>

            <h4>제8조 (개인정보의 안전성 확보 조치)</h4>
            <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
            <ul>
              <li>개인정보 취급 직원의 최소화 및 교육</li>
              <li>개인정보에 대한 접근 제한</li>
              <li>개인정보의 암호화</li>
              <li>해킹 등에 대비한 기술적 대책</li>
            </ul>

            <h4>제9조 (개인정보 보호책임자)</h4>
            <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해 구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
            <div class="privacy-contact">
              <p><strong>개인정보 보호책임자</strong></p>
              <p>성명: 백영민</p>
              <p>직책: 대표</p>
              <p>연락처: 1666-4139</p>
              <p>이메일: info@step1.kr</p>
            </div>

            <h4>제10조 (권익침해 구제 방법)</h4>
            <p>고객은 개인정보 침해로 인한 구제를 받기 위하여 다음 기관에 분쟁 해결이나 상담 등을 신청할 수 있습니다.</p>
            <ul>
              <li>개인정보분쟁조정위원회: (국번없이) 1833-6972</li>
              <li>개인정보침해신고센터: (국번없이) 118</li>
              <li>대검찰청 사이버수사과: (국번없이) 1301</li>
              <li>경찰청 사이버안전국: (국번없이) 182</li>
            </ul>

            <h4>제11조 (개인정보처리방침의 변경)</h4>
            <p>본 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 사이트를 통하여 고지할 것입니다.</p>
            <p class="privacy-date">본 개인정보처리방침은 2026년 3월 6일부터 시행됩니다.</p>
          </div>
        </div>
      </div>
    </transition>

  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
  data() {
    return {
      showPrivacy: false
    }
  },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    },
    currentYear() {
      return new Date().getFullYear()
    }
  },
  watch: {
    showPrivacy(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    }
  },
  methods: {}
}
</script>

<style scoped>
.site-footer {
  background: #1a1a1a;
  color: rgba(255, 255, 255, 0.6);
  font-family: var(--font-family, 'Pretendard Variable', 'Pretendard', sans-serif);
  padding-bottom: 100px;
}

.footer-inner {
  padding: 0 28px;
}

/* 상단: 프로젝트 정보 */
.footer-top {
  padding: 48px 0 36px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-project-name {
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  margin: 0;
  letter-spacing: -0.5px;
}

/* 고지사항 */
.footer-disclaimer {
  padding: 32px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-ad-agency {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 12px;
}

.footer-email {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-email:active {
  color: rgba(255, 255, 255, 0.8);
}

.footer-disclaimer-text {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 16px;
}

.footer-notices {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-notices p {
  font-size: 11px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.3);
}

/* 하단 */
.footer-bottom {
  padding: 28px 0;
  text-align: center;
}

.footer-privacy-btn {
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.6);
  font-family: var(--font-family);
  font-size: 12px;
  font-weight: 600;
  padding: 8px 20px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 16px;
}

.footer-privacy-btn:active {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.4);
}

.footer-copyright {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.2);
  font-family: 'Roboto', sans-serif;
}

/* 개인정보처리방침 모달 */
.privacy-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.privacy-modal {
  background: #fff;
  width: 100%;
  max-height: 85vh;
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.privacy-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.privacy-modal-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
}

.privacy-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.privacy-modal-body {
  padding: 24px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  color: #333;
  font-size: 13px;
  line-height: 1.8;
}

.privacy-intro {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}

.privacy-modal-body h4 {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 24px 0 10px;
}

.privacy-modal-body h4:first-of-type {
  margin-top: 0;
}

.privacy-modal-body ul {
  padding-left: 20px;
  margin: 8px 0;
}

.privacy-modal-body li {
  margin-bottom: 4px;
}

.privacy-table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
  font-size: 12px;
}

.privacy-table th,
.privacy-table td {
  border: 1px solid #ddd;
  padding: 10px 8px;
  text-align: left;
}

.privacy-table th {
  background: #f5f5f5;
  font-weight: 700;
  color: #1a1a1a;
}

.privacy-contact {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin: 12px 0;
}

.privacy-contact p {
  margin-bottom: 4px;
}

.privacy-date {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #eee;
  font-weight: 600;
  color: #1a1a1a;
}

/* 모달 트랜지션 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-active .privacy-modal,
.modal-fade-leave-active .privacy-modal {
  transition: transform 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .privacy-modal,
.modal-fade-leave-to .privacy-modal {
  transform: translateY(100%);
}
</style>
